// Full updated CourseDetails.jsx with score display and retake functionality
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient';
import AITutor from '../../components/AITutor';
import InteractiveQuiz from '../../components/InteractiveQuiz';
import QuizModal from '../../components/QuizModal';
import FinalExamModal from '../../components/FinalExamModal';
import { logEvent } from '../../utils/logEvent';


export default function CourseDetails() {
  const { slug } = useParams();
  const [course, setCourse] = useState(null);
  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [viewMode, setViewMode] = useState('accordion');
  const [isQuizOpen, setIsQuizOpen] = useState(false);
  const [activeQuiz, setActiveQuiz] = useState(null);
  const [userCourse, setUserCourse] = useState(null);
  const [userId, setUserId] = useState(null);
  const [finalQuestions, setFinalQuestions] = useState([]);
  const [finalExamOpen, setFinalExamOpen] = useState(false);
  const handleCourseLaunch = async () => {
  if (course?.id) {
    await logEvent('launch_course', { course_id: course.id });
  }
  // rest of launch logic
};


  useEffect(() => {
    async function fetchCourse() {
      setLoading(true);
      const { data, error } = await supabase
        .from('courses')
        .select('*')
        .eq('slug', slug)
        .single();
      if (error) console.error("Course fetch error:", error);
      else setCourse(data);
      setLoading(false);
    }
    fetchCourse();
  }, [slug]);

  useEffect(() => {
    async function fetchLessons() {
      if (!course?.id) return;
      const { data, error } = await supabase
        .from('lessons')
        .select('*')
        .eq('course_id', course.id);
      if (error) console.error("Lessons fetch error:", error);
      else setLessons(data);
    }
    fetchLessons();
  }, [course]);

  useEffect(() => {
    async function getUser() {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error) {
        console.error("Session fetch error:", error);
        return;
      }
      const uid = session?.user?.id;
      console.log("✅ Logged in user:", uid);
      setUserId(uid);
    }
    getUser();
  }, []);

  useEffect(() => {
    if (userCourse && course?.id && finalQuestions.length === 0) {
      console.log("📘 Refetching final exam questions...");
      fetchFinalExamQuestions();
    }
  }, [userCourse, course]);

  const launchCourse = async () => {
    if (!userId || !course?.id) return;

    console.log("🚀 Launching course with:", { userId, courseId: course.id });

    const { data: existing, error: fetchError } = await supabase
      .from('user_courses')
      .select('*')
      .eq('user_id', userId)
      .eq('course_id', course.id)
      .single();

    if (existing) {
      setUserCourse(existing);
      fetchFinalExamQuestions();
    } else {
      const { data, error } = await supabase
        .from('user_courses')
        .insert([
          {
            user_id: userId,
            course_id: course.id,
            status: 'in_progress',
            progress_percent: 0,
          }
        ])
        .select()
        .single();

      if (error) {
        console.error("❌ Launch error:", error);
      } else {
        setUserCourse(data);
        fetchFinalExamQuestions();
      }
    }
  };

  console.log("🧪 FinalQuestions in state:", finalQuestions);
console.log("🧪 userCourse status:", userCourse?.status);
console.log("🧪 userCourse progress:", userCourse?.progress_percent);


  const fetchFinalExamQuestions = async () => {
  console.log("📥 Fetching final exam questions...");
  console.log("🔍 Fetching final_quizzes for course_id:", course?.id);


  if (!course?.id) {
    console.warn("❌ No course ID available.");
    return;
  }

  const { data, error } = await supabase
    .from('final_quizzes')
    .select('*')
    .eq('course_id', course.id);

  if (error) {
    console.error("❌ Error fetching final quizzes:", error);
  } else {
    console.log("✅ Fetched final exam questions:", data);
    setFinalQuestions(data);
  }
};

 useEffect(() => {
  if (userCourse && course?.id && finalQuestions.length === 0) {
    console.log("📘 Auto-fetching final exam questions on page load...");
    fetchFinalExamQuestions();
  }
}, [userCourse, course]);

  const handleLessonView = async (index) => {
    if (!userCourse || !lessons.length) return;
    const percent = Math.round(((index + 1) / lessons.length) * 100);
    await supabase
      .from('user_courses')
      .update({ progress_percent: percent })
      .eq('id', userCourse.id);
    setUserCourse({ ...userCourse, progress_percent: percent });
  };

  const handleFinalQuiz = async (score) => {
    if (!userCourse) return;

    if (score >= 90) {
      await supabase
        .from('user_courses')
        .update({ final_score: score, status: 'completed', progress_percent: 100 })
        .eq('id', userCourse.id);

      setUserCourse({
        ...userCourse,
        final_score: score,
        status: 'completed',
        progress_percent: 100
      });
    } else {
      alert('Score below 90%. Please retake the test.');
    }
  };

  if (loading) return <p className="text-center mt-10">Loading course...</p>;
  if (!course) return <p className="text-center mt-10 text-red-600">Course not found.</p>;

  return (
    <main className="min-h-screen bg-white p-6 pt-24 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-indigo-800 mb-4">{course.title}</h1>
      <p className="text-gray-600 mb-6">{course.description}</p>

      {!userCourse ? (
        <button
          onClick={launchCourse}
          className="mb-6 px-4 py-2 bg-indigo-600 text-white rounded shadow hover:bg-indigo-700"
        >
          Launch Course
        </button>
      ) : (
        <div className="mb-6">
          <div className="h-4 w-full bg-gray-200 rounded-full">
            <div
              className="h-4 bg-indigo-600 rounded-full"
              style={{ width: `${userCourse.progress_percent}%` }}
            ></div>
          </div>
          <p className="text-sm mt-1 text-indigo-700">Progress: {userCourse.progress_percent}%</p>
        </div>
      )}

      <div className="flex justify-end mb-4">
        <button
          onClick={() => setViewMode(viewMode === 'accordion' ? 'paged' : 'accordion')}
          className="px-4 py-2 bg-indigo-100 text-indigo-800 rounded shadow"
        >
          Switch to {viewMode === 'accordion' ? 'Paginated View' : 'Accordion View'}
        </button>
      </div>

      <section>
        {lessons.length === 0 ? (
          <p className="text-gray-500 italic">No lessons found for this course yet.</p>
        ) : viewMode === 'accordion' ? (
          lessons.map((lesson, i) => (
            <details key={lesson.id} className="mb-4 border rounded-lg p-4 bg-gray-50" onClick={() => handleLessonView(i)}>
              <summary className="font-semibold text-indigo-700 text-lg cursor-pointer">{lesson.title}</summary>
              <div className="mt-4">
                {lesson.image_url && <img src={lesson.image_url} alt={lesson.title} className="rounded shadow mb-4 max-w-full" />}
                {lesson.content && <div className="prose prose-sm text-gray-700" dangerouslySetInnerHTML={{ __html: lesson.content }} />}
                {lesson.quiz_question && (
                  <button
                    onClick={() => {
                      setIsQuizOpen(true);
                      setActiveQuiz({ question: lesson.quiz_question, choices: lesson.quiz_choices, correctAnswer: lesson.correct_answer });
                    }}
                    className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                  >
                    Take Quiz
                  </button>
                )}
              </div>
            </details>
          ))
        ) : (
          <div className="mb-8 p-4 border rounded-lg shadow-sm bg-gray-50">
            <h2 className="text-xl font-semibold text-indigo-700 mb-2">{lessons[currentIndex].title}</h2>
            {lessons[currentIndex].image_url && <img src={lessons[currentIndex].image_url} alt={lessons[currentIndex].title} className="rounded shadow mb-4 max-w-full" />}
            {lessons[currentIndex].content && <div className="prose prose-sm text-gray-700" dangerouslySetInnerHTML={{ __html: lessons[currentIndex].content }} />}
            {lessons[currentIndex].quiz_question && (
              <button
                onClick={() => {
                  setIsQuizOpen(true);
                  setActiveQuiz({ question: lessons[currentIndex].quiz_question, choices: lessons[currentIndex].quiz_choices, correctAnswer: lessons[currentIndex].correct_answer });
                }}
                className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
              >
                Take Quiz
              </button>
            )}
            <div className="mt-6 flex justify-between">
              <button onClick={() => setCurrentIndex((i) => Math.max(i - 1, 0))} disabled={currentIndex === 0} className="px-4 py-2 bg-indigo-100 rounded disabled:opacity-50">Previous</button>
              <button onClick={() => { handleLessonView(currentIndex + 1); setCurrentIndex((i) => Math.min(i + 1, lessons.length - 1)); }} disabled={currentIndex === lessons.length - 1} className="px-4 py-2 bg-indigo-100 rounded disabled:opacity-50">Next</button>
            </div>
          </div>
        )}
      </section>

      {userCourse && finalQuestions.length > 0 && (
        <section className="mt-10 p-6 bg-indigo-50 border rounded-xl">
          <h3 className="text-xl font-semibold text-indigo-700 mb-4">Final Exam</h3>
          {userCourse.status !== 'completed' && userCourse.progress_percent === 100 ? (
            <>
              <p className="text-gray-700 mb-4">You have completed all lessons. Take the final exam to complete the course.</p>
              <button
                onClick={() => {
                  console.log("✅ Opening Final Exam Modal");
                  setFinalExamOpen(true);
                }}
                className="px-6 py-3 bg-indigo-600 text-white font-bold rounded hover:bg-indigo-700"
              >
                Take Final Exam
              </button>
            </>
          ) : userCourse.status === 'completed' ? (
            <>
              <p className="text-green-700 mb-2">🎉 You completed this course with a score of <strong>{userCourse.final_score}%</strong>.</p>
              <p className="text-gray-700 mb-4">Want to improve your score or refresh your knowledge?</p>
              <button
                onClick={() => {
                  console.log("♻️ Retaking Final Exam");
                  setFinalExamOpen(true);
                }}
                className="px-6 py-3 bg-yellow-500 text-white font-bold rounded hover:bg-yellow-600"
              >
                Retake Final Exam
              </button>
            </>
          ) : null}
        </section>
      )}

      {course.ai_enabled && (
        <section className="mt-12 border-t pt-6">
          <h2 className="text-2xl font-semibold text-indigo-700 mb-4">Ask the AI Tutor</h2>
          <AITutor courseTitle={course.title} />
        </section>
      )}

      <QuizModal
        open={isQuizOpen}
        onClose={() => setIsQuizOpen(false)}
        question={activeQuiz?.question}
        choices={activeQuiz?.choices}
        correctAnswer={activeQuiz?.correctAnswer}
      />

      <FinalExamModal
        open={finalExamOpen}
        onClose={() => setFinalExamOpen(false)}
        questions={finalQuestions}
        onFinish={handleFinalQuiz}
      />
    </main>
  );
}
